import React, { useEffect, useState } from "react";
import SidebarSolicitante from "../../components/sidebar_solicitante/Sidebar_Solicitante";
import Axios from "axios";
import { useHistory } from "react-router-dom";
import { formatDate } from "../../utils/date";

const MinhasTelecEncerradas = (props) => {
  const abrir = (id) => {
    history.push({
      pathname: "/solicitante/detalhes",
      state: { detail: id },
    });
  };
  let history = useHistory();

  Axios.defaults.withCredentials = true;

  const [lista, setLista] = useState([]);
  const [nomeSolicitante, setNomeSolicitante] = useState("");

  useEffect(() => {
    /*
    Axios.defaults.withCredentials = false;
      Axios.post(`${process.env.REACT_APP_API_BASE_URL}/minhasTelecEncerradas`, {cpf: cpfTeste}).then((response) => {
          if(response.data.message){
              alert(response.data.message);
          }
          
          setLista(response.data);
      })
      */
    Axios.defaults.withCredentials = false;

    Axios.get(`${process.env.REACT_APP_API_BASE_URL}/loginCPF`, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    }).then((response) => {
      Axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/minhasTelecEncerradas`,
        {
          cpf: response.data,
        }
      ).then((response) => {
        if (response.data.message) {
          alert(response.data.message);
        } else {
          console.log(response);
          setLista(response.data);
        }
      });
    });
  }, []);

  const chatTeleconsultoria = (id) => {
    history.push({
      pathname: "/solicitante/chatTeleconsultoria",
      state: { room: id, nomeSolicitante: nomeSolicitante },
    });
  };

  return (
    <>
      <SidebarSolicitante>
        <div class="main__container">
          <table class="content-table">
            <thead>
              <tr>
                <th>DATA</th>
                <th>ÁREA INTERESSE</th>
                <th>CHAT</th>
                <th>STATUS</th>
                <th>AÇÃO</th>
              </tr>
            </thead>
            <tbody align="justify">
              {lista.map((item) => (
                <tr>
                  <th>{formatDate(item.data_hora)}</th>
                  <th>{item.area_interesse}</th>
                  <th>
                    {" "}
                    <a
                      style={{ cursor: "pointer" }}
                      id={item.id}
                      onClick={(e) => chatTeleconsultoria(e.target.id)}
                    >
                      Abrir
                    </a>
                  </th>
                  <th>{item.status}</th>
                  <th>
                    <a
                      id={item.id}
                      style={{ cursor: "pointer" }}
                      onClick={(e) => abrir(e.target.id)}
                    >
                      Abrir
                    </a>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </SidebarSolicitante>
    </>
  );
};

export default MinhasTelecEncerradas;
